export default {
    "@ofa/header-app": {},
    "@ofa/alg-app": { basePath: "alg" },
    "@ofa/viaco-app": { basePath: "viaco" },
    "@ofa/panda-app": { basePath: "panda" }
};